
export function limitCharacters (string, characters) {
  return (string.length > characters)
    ? string.substr(0, characters - 2) + '…'
    : string
}

export function toFirebaseKey (s) {
  return s.replace(/[/.$[\]#+]+/g, '_')
}

export function toAppName (s) {
  return s.replace(/[/.$[\]#+ ]+/g, '_')
}

export function hashCode (s) {
  let h = 0
  const l = s.length
  let i = 0
  if (l > 0) {
    while (i < l) {
      h = (h << 5) - h + s.charCodeAt(i++) | 0
    }
  }
  return h
}

export function trackEvent (event) {
  mixpanel.track(event) // eslint-disable-line no-undef
}

export function getABTestingGroup (userId) {
  const hash = hashCode(userId)
  const testGroup = (hash % 2 === 0) ? 'a' : 'b'
  console.log('getABTestingGroup: ', testGroup)
  return testGroup
}



// WEBPACK FOOTER //
// ./src/utils/utils.js